import { render } from "./Chat-Bot.vue?vue&type=template&id=6d839d98&scoped=true"
import script from "./Chat-Bot.vue?vue&type=script&lang=js"
export * from "./Chat-Bot.vue?vue&type=script&lang=js"

import "./Chat-Bot.vue?vue&type=style&index=0&id=6d839d98&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6d839d98"]])

export default __exports__